import { useTranslation } from 'react-i18next';
import React, { useState, useContext, useEffect } from 'react';
import { GRAPHICS, RESULTS, PROJECTION_PERIOD } from './constants'
import { VIEW, UPDATE, ADD_BENEFIT, OPEN, COPY, DELETE, NEW, UNLOCK, CALCULATE } from '../../assets/Constants/actionsTypes';
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useHistory } from "react-router-dom";
import './scenario.css';
// * Scenarios grid component
import ScenarioGrid from './scenarioGrid'
// * Scenarios modal
import ScenarioModal from './scenarioModal'
// * Helpers
import validator from 'validator';
import API from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';
import MatrixContext from '../../assets/Constants/matrixContext';

function Scenario() {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');
    // Modal Window type = DELETE, NEW, VIEW or UPDATE
    const [viewType, setViewType] = useState('');
    // Single component
    const [scenariosData, setScenariosData] = useState({});
    /**State of the modal window. True = showing ... False = hidden */
    const [showModal, setShowModal] = useState(false);
    /** State of the dialog. True = showing ... False = hidden */
    const [showAlert, setShowAlert] = useState(false);
    // List of scenarios. See useEffect
    const [scenariosList, setScenariosList] = useState([]);
    // Session context to get the current institution data
    const { get_currentInstitution, user } = useContext(AuthContext);
    /**The useHistory hook allow us to redirect to another route */
    const history = useHistory();

    // we use useEffect to call the function that fills the grid
    useEffect(() => {
        //console.log("Hola");
        getScenariosList();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const getScenariosList = async () => {
        setScenariosList([]);
        try {
            // data from API
            const response = await API.get(`/scenario/getAll?institutionId=${get_currentInstitution().catInstitutionId}`);
            setScenariosList(response.data.data === null ? [] : response.data.data);
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // Triggered when the user clicks an action in the grid. Opens the modal window according to the selection
    const onActionClick = (actionItem, dataItem) => {
        const action = actionItem.value;
        setViewType(action);
        setScenariosData(dataItem);

        switch (action) {
            case NEW:
                toggleWindow();
                break;
            case VIEW:
                toggleWindow();
                break;
            case UPDATE:
                toggleWindow();
                break;
            case DELETE:
                toggleAlert();
                break;
            case COPY:
                toggleAlert();
                break;
            case ADD_BENEFIT:
                onAddBenefit(dataItem);
                break;
            case UNLOCK:
                onUnlock(dataItem);
                break;
            case OPEN:
                onOpenScenario(dataItem)
                break;
            case CALCULATE: // This Action was originally part of Matrix Dashboard
                toggleAlert();
                break;
            case RESULTS: // This Action was originally part of Matrix Dashboard
                onOpenScenarioResults(dataItem)
                break;
            case GRAPHICS: // This Action was originally part of Matrix Dashboard
                onOpenScenarioGraphics(dataItem)
                break;
            default:
                break;
        }
    }

    // * When user clicks UNLOCK in one model
    const onUnlock = async (scenarioData) => {
        try {
            const response = await API.get(`/Scenario/UnlockScenario?scenarioId=${scenarioData.scenarioId}`);

            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                Notifications.notify(t('scenarios.unlocked_scenario'), SUCCESS_NOTIFICATION);

                getScenariosList();
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    const onOpenScenario = async (scenarioData) => {
        try {
            // Check if Scenario is currently locked
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);
            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }
            const isLockData = isLockRes.data.data;
            if (isLockData.isLock) {
                Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                return;
            }
            // ========================================

            // Navigate to Matrix Control
            history.push({
                pathname: '/MatrixControl',
                state: {
                    code: PROJECTION_PERIOD,
                    detail: scenarioData
                }
            });

            // Previously onOpenScenario opened the matrix Dashboard component:
            // history.push({
            //     pathname: '/Dashboard',
            //     state: {
            //         detail: scenarioData
            //     }
            // });
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    const onOpenScenarioResults = async (scenarioData) => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;

            if (isLockData.isLock) { 
                Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                return;
            }

            if (!isLockData.isCalculated) {
                Notifications.notify(t('scenarios.not_calculated_results'), ERROR_NOTIFICATION);
                return;
            }

            // * If model is not locked by other user and it is already calculated we let user navigate to results...
            goToResults(scenarioData);
            
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    // Navigates to the matrix control with the code of the node that should be open in the tree (Taken from dahboard.js implementation)
    const goToResults = (scenarioData) => {
        history.push({
            pathname: '/MatrixControl',
            state: {
                code: RESULTS,
                detail: scenarioData
            }
        });
    }


    const onOpenScenarioGraphics = async (scenarioData) => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;

            if (isLockData.isLock) { 
                Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                return;
            }

            if (!isLockData.isCalculated) {
                Notifications.notify(t('scenarios.not_calculated_results'), ERROR_NOTIFICATION);
                return;
            }

            // * If model is not locked by other user and it is already calculated we let user navigate to graphics...
            goToScenarioGraphics(scenarioData);
            
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    const goToScenarioGraphics = (scenarioData) => {
        history.push({
            pathname: '/Graph',
            state: {
                code: GRAPHICS,
                detail: scenarioData
            }
        });
    }


    //* When user clicks the Calculate button
    const onCalculate = async (scenarioData) => {
        // ToDo: Improve handling of Lock and Checkout to guard against concurrence issues: see bug #9477
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);
            const isCehckoutRes = await API.get(`/Scenario/IsCheckout?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            if (isCehckoutRes.data.code !== 100) {
                Notifications.notify(isCehckoutRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;
            const isCheckoutData = isCehckoutRes.data.data;


            // * If scenario is not locked by other user
            if (!isLockData.isLock && !isCheckoutData) {
                await API.get(`/Scenario/LockScenario?scenarioId=${scenarioData.scenarioId}&userCode=system`);
                const response = await API.post(`Scheduler/addTask`, null, {
                    params: {
                        ctxtcode: MatrixContext.SCENARIO,
                        scenarioid: scenarioData.scenarioId,
                        opcode: 'CAL',
                        usrcode: user ? user.email : 'get_user_error',
                        customparams: JSON.stringify({ runblocks: ['load_data', 'gaps', 'projections', 'calc_rpt', 'make_reports'] })
                    }
                });
                if (response.data.code !== 100) {
                    Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                    toggleAlert();
                    return;
                }
                Notifications.notify(t('scenarios.calculate_success'), SUCCESS_NOTIFICATION);
                toggleAlert();
            } else {
                // **** If not, error is displayed
                if (isLockData.isLock) {
                    Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                    return;
                } else if (isCheckoutData) {
                    Notifications.notify(t('scenarios.add_benefit.ischeckout'), ERROR_NOTIFICATION);
                    return;
                }
            }
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    // * When user clicks Add Benefit in one scenario
    const onAddBenefit = async (scenarioData) => {

        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);
            const isCehckoutRes = await API.get(`/Scenario/IsCheckout?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            if (isCehckoutRes.data.code !== 100) {
                Notifications.notify(isCehckoutRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;
            const isCheckoutData = isCehckoutRes.data.data;


            // * If model is not lock by other user
            if (!isLockData.isLock && !isCheckoutData) {
                // * call the api to lock the model
                const res = await API.get(`/Scenario/LockScenario?scenarioId=${scenarioData.scenarioId}&userCode=${user.email}`);

                // * if errors exist, it is displayed as a notification
                if (res.data.code !== 100) {
                    Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                    return;
                } else {
                    // * If all ok, the system shows the add benefit
                    history.push({
                        pathname: '/AddScenarioBenefit',
                        state: {
                            detail: scenarioData
                        }
                    });
                    return;
                }
            } if (isLockData.editLockUserCode === user.email && !isCheckoutData) {
                // * If all ok, the system shows the add benefit
                history.push({
                    pathname: '/AddScenarioBenefit',
                    state: {
                        detail: scenarioData
                    }
                });
                return;
            } else {
                // **** If not, error is displayed
                if (isLockData.isLock) {
                    Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                    return;
                } else if (isCheckoutData) {
                    Notifications.notify(t('scenarios.add_benefit.ischeckout'), ERROR_NOTIFICATION);
                    return;
                }
            }
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
        }
    }

    // Show or hide the modal window. See state variable
    const toggleWindow = () => {
        setShowModal(!showModal);
    }

    // Show or hide the alert dialog. See state variable
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    }

    // Shows the Alert title according to the selected action 
    const showAlertTitle = () => {
        switch (viewType) {
            case DELETE: return t('scenarios.delete_title'); break;
            case COPY: return t('scenarios.copy_title'); break;
            case CALCULATE: return t('scenarios.calculate_title'); break;
            default: return 'UNDEFINED';
        }
    }

    // Shows the Alert body according to the selected action 
    const showAlertBody = () => {
        switch (viewType) {
            case DELETE: return t('scenarios.delete_body'); break;
            case COPY: return t('scenarios.copy_body'); break;
            case CALCULATE: return t('scenarios.calculate_body'); break;
            default: return 'UNDEFINED';
        }
    }

    // Decides which function to call according to the selected action on the Alert dialog
    const actionOrchestrator = () => {
        switch (viewType) {
            case DELETE: onDelete(); break;
            case COPY: onCopy(); break;
            case CALCULATE: onCalculate(scenariosData); break;
            default: console.log(`UNDEFINED ACTION FIRED FOR ${viewType}`);
        }
    }

    // Copy action
    const onCopy = async () => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenariosData.scenarioId}&userCode=${user.email}`);
            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;

            // * If model is not lock by other user
            if (!isLockData.isLock) {
                // * call the api to do copy
                const res = await API.get(`/scenario/CopyScenario?scenarioId=${scenariosData.scenarioId}&usercode=${user.email}`);

                // * if errors exist, it is displayed as a notification
                if (res.data.code !== 100) {
                    Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                    return;
                }
                // * hide the alert and refresh the grid
                toggleAlert();
                Notifications.notify(t('scenarios.copy_message'), SUCCESS_NOTIFICATION);
                getScenariosList();
            } else {
                toggleAlert();
                Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                return;
            }

        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // Delete action
    const onDelete = async () => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${scenariosData.scenarioId}&userCode=${user.email}`);
            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;

            // * If model is not lock by other user
            if (!isLockData.isLock) {
                // * call the api to do the delete
                const res = await API.delete(`/scenario?scenarioId=${scenariosData.scenarioId}&usercode=${user.email}`);

                // * if errors exist, it is displayed as a notification
                if (res.data.code !== 100) {
                    Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                    return;
                }

                // * hide the alert and refresh the grid
                toggleAlert();
                Notifications.notify(t('scenarios.delete_message'), SUCCESS_NOTIFICATION);
                getScenariosList();
            } else {
                toggleAlert();
                Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                return;
            }

        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // Save action
    const onSave = async (data) => {
        try {
            // * Validations
            if (validator.isEmpty(data.code.toString()) || validator.isEmpty(data.name.toString()) || data.modelId === 0 || validator.isEmpty(data.finalYear.toString())) {
                Notifications.notify(t('scenarios.name_code_required'), ERROR_NOTIFICATION);
                return;
            }
            if (!validator.isFloat(data.finalYear.toString())) {
                Notifications.notify(t('scenarios.finalYear_number'), ERROR_NOTIFICATION);
                return;
            }
            if (data.finalYear <= 0) {
                Notifications.notify(t('scenarios.finalYear_real'), ERROR_NOTIFICATION);
                return;
            }
            if (data.finalYear < data.baseYear) {
                Notifications.notify(t('scenarios.final_less_base'), ERROR_NOTIFICATION);
                return;
            }

            //!We assume a maximum of 50 years to be projected.
            if (data.finalYear - data.baseYear > 50) {
                Notifications.notify(t('scenarios.max_projection'), ERROR_NOTIFICATION);
                return;
            }

            // * Data to be sent
            // * we apply the trim to the fields
            const dataScenarioData = {
                scenarioId: data.scenarioId,
                institutionId: get_currentInstitution().catInstitutionId,
                code: validator.trim(data.code),
                name: validator.trim(data.name),
                modelId: data.modelId,
                description: data.description,
                finalYear: parseInt(data.finalYear, 10)
            }

            // * call the api to do the upsert
            const res = await API.post('/scenario/upsert', dataScenarioData);

            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
                return;
            }


            if (data.scenarioId === 0) {
                await API.get(`/Scenario/LockScenario?scenarioId=${res.data.data}&userCode=system`);
                // * add scenario generate task
                const response = await API.post(`Scheduler/addTask`, null, {
                    params: {
                        ctxtcode: MatrixContext.SCENARIO,
                        scenarioid: res.data.data,
                        opcode: 'CRE',
                        usrcode: user ? user.email : 'get_user_error',
                        customparams: JSON.stringify({ runblocks: ['load_data', 'gaps', 'init_elc', 'init_mtx'] })
                    }
                });
                if (response.data.code !== 100) {
                    Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                }
            }

            // * we decide what kind of message of success we should give
            const msg = data.scenarioId === 0 ? t('scenarios.new_message') : t('scenarios.update_message');

            // * hide the modal and refresh the grid
            toggleWindow();
            Notifications.notify(msg, SUCCESS_NOTIFICATION);
            getScenariosList();
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <button className="btn btn-primary ilo-btn" onClick={() => onActionClick({ value: NEW }, {})}>{t('model.new_button')}</button> | <span className="ilo-section-title p-1">{t('scenarios.modalTitle')}</span>
                </div>
            </div>
            <div className="container-fluid mt-1">
                {/* modal window */}
                {showModal && <ScenarioModal type={viewType} data={scenariosData} toggleWindow={toggleWindow} onSave={onSave} />}

                {/* alert window */}
                {showAlert &&
                    <Dialog
                        className="ilo-delete-confirm"
                        title={showAlertTitle()}
                        onClose={() => toggleAlert()}
                    >
                        <p style={{ margin: "25px", textAlign: "center" }}>{showAlertBody()}</p>
                        <DialogActionsBar layout="end">
                            <button className="k-button" onClick={actionOrchestrator}>{t('alerts.yes_btn')}</button>
                            <button className="k-button" onClick={toggleAlert}>{t('alerts.no_btn')}</button>
                        </DialogActionsBar>
                    </Dialog>
                }

                {/* grid */}
                <div className="row">
                    <div className="container_grid">
                        <ScenarioGrid data={scenariosList} onActionClick={onActionClick} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Scenario